import { LoadingContainer } from 'app/components/LoadingContainer';
import { downloadPdfApi, downloadTicketPdfApi } from 'app/services/checkoutApi';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { PRINT_TICKETS_GUEAST_FLOW_DATA } from '.';

const PDFViewer = () => {
  const location = useLocation();
  const { id }: { id: string } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  useEffect(() => {
    const orderId = searchParams.get('orderId') || '';
    const orderItemId = searchParams.get('orderItemId') || '';
    const code = searchParams.get('code') || '';
    const vgsTicketId = searchParams.get('vgsTicketId') || '';
    const printTicketsGuestFlowData = JSON.parse(
      sessionStorage.getItem(PRINT_TICKETS_GUEAST_FLOW_DATA) || '{}',
    );
    const { otp, guest } = printTicketsGuestFlowData;
    if (orderId && orderItemId && code && vgsTicketId) {
      const params: Record<string, any> = {
        orderId,
        orderItemId,
        code,
        vgsTicketId,
      };
      if (!!otp && !!guest) {
        params.otp = otp;
        params.guest = guest;
      }
      downloadTicketPdfApi(params, setIsLoading);
      return;
    }
    downloadPdfApi(id, setIsLoading);
  }, [id, searchParams]);

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: '100vw',
        height: '100vh',
        background: 'white',
        zIndex: 1000,
      }}
    >
      <LoadingContainer loading={isLoading}>
        <div style={{ display: 'flex', flex: 1 }} />
      </LoadingContainer>
    </div>
  );
};

export default PDFViewer;
